import React from 'react';
import cn from 'classnames';
import { useTheme } from '@hooks/use-theme';
import {
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingToggle,
} from '@views/Settings/components';
import styles from './Appearance.module.scss';

const lightThemeImg = '/img/themes/light.png';
const darkThemeImg = '/img/themes/dark.png';
const darkBlackThemeImg = '/img/themes/dark-black.png';
const darkGraphiteThemeImg = '/img/themes/dark-graphite.png';

function Theme({ onClick, selected, uiImage, title, splotch }) {
  return (
    <div className={cn(styles.theme, selected && styles.selected)} onClick={onClick}>
      <div className={styles.imgContainer}>
        <img src={uiImage} />
      </div>
      <div className={styles.themeTitle}>
        <div className={cn(styles.splotch, styles[splotch])} />
        {title}
      </div>
    </div>
  );
}

function ThemeVariant({ onClick, selected, uiImage }) {
  return (
    <div className={cn(styles.themeVariant, selected && styles.selected)} onClick={onClick}>
      <img src={uiImage} />
    </div>
  );
}

export default function AppearanceSettingsPanel() {
  const [
    _themeName,
    _themeFamily,
    themePreference,
    setThemePreference,
    darkThemePreference,
    setDarkThemePreference,
  ] = useTheme();

  return (
    <Section>
      <SettingsSectionLabel>Theme</SettingsSectionLabel>
      <SettingsSectionBox className={styles.container}>
        <SettingToggle
          title="Automatic Light/Dark"
          checked={themePreference === 'auto'}
          name="autoTheme"
          onChange={() => setThemePreference(themePreference !== 'auto' ? 'auto' : 'light')}
        />
        <p>Matches device settings</p>
        <div className={styles.themesContainer}>
          <Theme
            onClick={() => setThemePreference('dark')}
            uiImage={darkThemeImg}
            title="Dark"
            selected={themePreference === 'dark'}
            splotch="dark"
          />
          <Theme
            onClick={() => setThemePreference('light')}
            uiImage={lightThemeImg}
            title="Light"
            selected={themePreference === 'light'}
            splotch="light"
          />
        </div>
      </SettingsSectionBox>
      <SettingsSectionBox
        className={cn(
          styles.darkModePreferencePicker,
          themePreference === 'light' && styles.disabled,
        )}
      >
        <div className={styles.copy}>
          <div>Dark Appearance</div>
          <p>
            Choose your preferred dark appearance by toggling between{' '}
            <span className={cn(darkThemePreference === 'dark-black' && styles.selected)}>
              Black
            </span>{' '}
            or{' '}
            <span className={cn(darkThemePreference === 'dark-graphite' && styles.selected)}>
              Graphite
            </span>
          </p>
        </div>
        <ThemeVariant
          onClick={() => setDarkThemePreference('dark-black')}
          uiImage={darkBlackThemeImg}
          selected={darkThemePreference === 'dark-black'}
        />
        <ThemeVariant
          onClick={() => setDarkThemePreference('dark-graphite')}
          uiImage={darkGraphiteThemeImg}
          selected={darkThemePreference === 'dark-graphite'}
        />
      </SettingsSectionBox>
    </Section>
  );
}
